export { default as SimPrice } from './SimPrice.container';
